import { render, staticRenderFns } from "./DocumentoCard.vue?vue&type=template&id=5c32edb2&scoped=true"
import script from "./DocumentoCard.vue?vue&type=script&lang=js"
export * from "./DocumentoCard.vue?vue&type=script&lang=js"
import style0 from "./DocumentoCard.vue?vue&type=style&index=0&id=5c32edb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c32edb2",
  null
  
)

export default component.exports